// extracted by mini-css-extract-plugin
module.exports = {"root":"v_M","caption":"v_bt f_t","imageShadow":"v_bv"};